export default __webpack_public_path__ + "static/media/clip.1fd151f6.svg";